//WE.Flow.Html.Contracts.Manifests.Components.SideTabManifest

export class SideTabManifest {
    isSideTab: boolean = false;
    id: string = "";
    name: string = "";
    defaultParameters: any = null;
    viewUrl: string = "";
    namespace: string = "";
    viewModelId: string = "";
    reuseInstance: boolean = false;
    cssUrls: string[] = null;
    moduleRoles: string[] = null;
    useValidationV3: boolean = false;
    tags: string[] = null;
}
